import "../../../node_modules/video-react/dist/video-react.css";

import { lazy, Suspense } from "react";
import Breadcrumbs from "src/components/shared/Breadcrumbs/Breadcrumbs";
import TileGrid, {
  GridLoader,
} from "src/components/shared/NavigationTile/TileGrid";
import { getOrigin } from "src/environment";
import { PageContainer } from "src/styled";

const VideoCard = lazy(
  async () =>
    await import("src/components/pages/HelpVideos/VideoCard/VideoCard"),
);

const HelpVideos = () => {
  return (
    <PageContainer>
      <Breadcrumbs />
      <Suspense fallback={<GridLoader />}>
        <TileGrid>
          <VideoCard
            imgSrc="./assets/1.png"
            vidSrc={getOrigin() + "/static/videos/Welcome to eLogbooks.mp4"}
          />
          <VideoCard
            imgSrc="./assets/2.png"
            vidSrc={getOrigin() + "/static/videos/Create an Entry.mp4"}
          />
          <VideoCard
            imgSrc="./assets/3.png"
            vidSrc={getOrigin() + "/static/videos/Edit an Entry.mp4"}
          />
          <VideoCard
            imgSrc="./assets/4.png"
            vidSrc={getOrigin() + "/static/videos/Verify an Entry.mp4"}
          />
          <VideoCard
            imgSrc="./assets/5.png"
            vidSrc={getOrigin() + "/static/videos/Withdraw an Entry.mp4"}
          />
        </TileGrid>
      </Suspense>
    </PageContainer>
  );
};

export default HelpVideos;
